var React = require('react');

function Flickr (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#ffffff","d":"M8 0c-4.418 0-8 3.606-8 8.055s3.582 8.055 8 8.055 8-3.606 8-8.055-3.582-8.055-8-8.055zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5z"}));
}

Flickr.defaultProps = {"version":"1.1","width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Flickr;

Flickr.default = Flickr;
